import { render } from "./ContentsRegComponent.vue?vue&type=template&id=5adbbcbd&scoped=true&ts=true"
import script from "./ContentsRegComponent.vue?vue&type=script&lang=ts"
export * from "./ContentsRegComponent.vue?vue&type=script&lang=ts"

import "./ContentsRegComponent.vue?vue&type=style&index=0&id=5adbbcbd&scoped=true&lang=css"
import "./ContentsRegComponent.vue?vue&type=style&index=1&id=5adbbcbd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5adbbcbd"]])

export default __exports__